import { render, staticRenderFns } from "./RegistrationEmail.vue?vue&type=template&id=6206513a&scoped=true&"
import script from "./RegistrationEmail.vue?vue&type=script&lang=js&"
export * from "./RegistrationEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationEmail.vue?vue&type=style&index=0&id=6206513a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206513a",
  null
  
)

export default component.exports